// extracted by mini-css-extract-plugin
export default {"title":"graphItem_title__-BnYj"};